// @ts-nocheck
import React from 'react';
import { cn } from '../../lib/utils';

/** @param {{ tabs?: Array<any>, activeTab?: any, onTabChange?: any, className?: string }} props */
export default function Tabs({ tabs = [], activeTab, onTabChange, className = '' }) {
  return (
    <div className={cn('flex gap-1 border-b border-gray-200 dark:border-gray-800', className)}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={cn(
            'flex items-center gap-2 px-4 py-2.5 text-sm font-medium transition-all duration-200',
            'border-b-2 -mb-px rounded-t-lg',
            activeTab === tab.id
              ? 'border-[hsl(var(--primary))] text-[hsl(var(--primary))] dark:text-[hsl(var(--primary)_/_0.7)] dark:border-[hsl(var(--primary)_/_0.7)] bg-[hsl(var(--primary)_/_0.08)] dark:bg-[hsl(var(--primary)_/_0.1)]'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300',
          )}
        >
          {tab.icon && <span className="w-4 h-4">{tab.icon}</span>}
          {tab.label}
        </button>
      ))}
    </div>
  );
}
